<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">BLUES <br/></strong><strong class="bold">FOR OUTLAW HEARTS</strong><strong class="bold"> <br/></strong><strong class="bold">AND OLD WHORES</strong></h1>
<p class="basic-paragraph"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// blues-for-outlaw-hearts_00000.vue?ce2006b6